import React, {Component} from 'react'
import {
  CCol,
  CRow,
  CButton,
  CCard,
  CCardBody,
  CCardFooter,
  CFormGroup,
  CForm,
  CLabel,
  CInput,
  CFormText,
  CSelect
} from '@coreui/react'
import withNavigation from './withNavigation';
import { apiRequest } from "../../services/api-request";
import { Editor } from '@tinymce/tinymce-react';
import "./dateStyles.css";

class add extends Component {
	constructor(props) {
        super(props);
        this.state = {
        	showLoader:false,
        	fields:{},
        	errors:{},
        	answer:''
        };
    }

    handleCancel(){
    	this.props.navigate('/faq/view');
    }

    handleChange(field, e){
    	let fields = this.state.fields
    	if(field === 'answer'){
    		fields[field] = e;
    	}
    	else{
    		fields[field] = e.target.value;
    	}
    	this.setState({fields})
    }

    validation(){
    	let fields = this.state.fields;
    	let languages = this.state.languages;
        let errors = {};
        let formIsValid = true;

        if(!fields["user_type"]){
            formIsValid = false;
            errors["user_type"] = "Please select user type.";
        }
        if(!fields["question"]){
            formIsValid = false;
            errors["question"] = "Please enter question.";
        }
        if(!fields["answer"]){
            formIsValid = false;
            errors["answer"] = "Please enter answer.";
        }

        this.setState({errors: errors});
        return formIsValid;
    }

	submit() {
		if(this.validation()){
			this.setState({showLoader:true})
			apiRequest({
	            url: 'master/add-faqs',
	            method: "POST",
	            data: JSON.stringify(this.state.fields)
	        }).then((res) => {
	            this.setState({showLoader:false})
				this.handleCancel()
	        })
	        .catch((err) => {
	            console.error("Error fetching states:", err?.response?.data?.message || err.message);
	            alert(err?.response?.data?.message || "Failed to fetch states");
	        });
		}
	}

    render() {
	  	return (
	  		<CRow>
	  			<div className="loader-img" style={{display: this.state.showLoader ? 'block' : 'none' }}></div>
        		<CCol xs="12" md="12">
          			<CCard>
	            		<CCardBody>
	            			<CForm className="form-horizontal">
	            				<CFormGroup row>
				                  	<CCol md="6">
				                    	<CLabel htmlFor="hf-Status">User Type</CLabel>
				                    	<CSelect custom onChange={this.handleChange.bind(this,'user_type')} value={this.state.fields.user_type}>
					                      	<option value="">--Select Type--</option>
					                      	<option value="LOAN_OFFICER">Loan Officer</option>
					                      	<option value="VETERINARY">Veterinary</option>
					                    </CSelect>
				                    	<CFormText className="help-block">{this.state.errors.user_type}</CFormText>
				                  	</CCol>				        
				                	<CCol md="12">
				                    	<CLabel htmlFor="hf-Type">Question</CLabel>
				                    	<CInput type="text" placeholder="Enter question" onChange={this.handleChange.bind(this, 'question')} value={this.state.fields['question']} />
		                    			<CFormText className="help-block">{this.state.errors['question']}</CFormText>
				                  	</CCol>
				                  	<CCol md="12">
				                    	<CLabel htmlFor="hf-Type">Answer</CLabel>
				                    	<Editor
                                            initialValue={this.state.answer}
                                            onEditorChange={this.handleChange.bind(this, 'answer')}
                                            apiKey="8e5ycymovq2x6x13yevas6ytjx00ghsnsrubpetkfaghkcd0"
                                            init={{
                                            	selector: 'textarea#file-picker',
									        	file_picker_types: 'image',
									        	image_title: true,
									        	automatic_uploads: true,
									        	file_picker_callback: function (cb, value, meta) {
												    var input = document.createElement('input');
												    input.setAttribute('type', 'file');
												    input.setAttribute('accept', 'image/*');
												    input.onchange = function () {
												      	var file = this.files[0];

												      	var reader = new FileReader();
												      	reader.onload = function () {
													        var id = 'blobid' + (new Date()).getTime();
													        var blobCache =  window.tinymce.activeEditor.editorUpload.blobCache
													        var base64 = reader.result.split(',')[1];
													        var blobInfo = blobCache.create(id, file, base64);
													        blobCache.add(blobInfo);
												        	cb(blobInfo.blobUri(), { title: file.name });
												      	};
												      	reader.readAsDataURL(file);
												    };
												    input.click();
												},
									           	height: 500,
									           	menubar: false,
									           	plugins: [
									             	'advlist autolink lists link image charmap print preview anchor',
									             	'searchreplace visualblocks code fullscreen',
									             	'insertdatetime media table paste code help wordcount',
									           	],
									           	toolbar: 'undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help | image | code',
									        }}
	                                    />
		                    			<CFormText className="help-block" style={{color:'red'}}>{this.state.errors['answer']}</CFormText>
				                  	</CCol>
				                </CFormGroup>
				            </CForm>
			            </CCardBody>
			            <CCardFooter>
			            	<CButton color="primary" className="px-4" onClick={this.submit.bind(this)}>Submit</CButton>{' '}
			            	<CButton color="danger" className="px-4" onClick={this.handleCancel.bind(this)}>Cancel</CButton>
			            </CCardFooter>
		            </CCard>
		        </CCol>  
		    </CRow>      
	  	)
    }
}

export default withNavigation(add);
